import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-cooking-story-player',
  templateUrl: './cooking-story-player.component.html',
  styleUrls: ['./cooking-story-player.component.scss'],
})
export class CookingStoryPlayerComponent implements AfterViewInit {
  @Input() data: { src: string; start: number; end: number; holder: string };
  @Input() isTutorial: boolean = true;
  @Input() set show(data: boolean) {
    if (this.isTutorial) {
      setTimeout(() => {
        if (data) {
          this.video.src = this.data.src;
          this.video.currentTime = this.data.start ?? 0;
          this.iosHandler();
        } else {
          this.video.src = '';
          this.loaded = false;
        }
      }, 300);
    }
  }
  @ViewChild('player') player: ElementRef<HTMLDivElement>;
  played: boolean = false;
  video: HTMLVideoElement = document.createElement('video');
  videoReady: boolean = false;
  loaded: boolean = false;
  isIos: boolean = false;
  videoHeight: number;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  ngAfterViewInit() {
    this.initailing();
  }
  initailing() {
    const video = this.video;
    video.src = this.data.src;
    video.currentTime = this.data.start ?? 0;
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      video.autoplay = true;
      this.isIos = true;
      this.loaded = true;
      this.played = true;
      video.setAttribute('playsinline', 'true');
      video.setAttribute('controls', 'true');
      video.setAttribute('poster', this.data.holder);
      video.setAttribute('preload', 'metadata');
    }

    if (this.isTutorial) {
      video.width = window.innerWidth - 48;
      video.style.borderRadius = '24px';
      video.style.margin = '0 auto';
    } else {
      video.width = window.innerWidth;
    }

    video.classList.add('player');

    this.handler();
    this.player.nativeElement.appendChild(this.video);
    setTimeout(() => {
      this.videoHeight = document.querySelector('video').clientHeight;
    }, 30);
    this.changeDetectorRef.detectChanges();
  }
  play(data) {
    this.played = data;
    if (data) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }
  handler() {
    if (!/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      this.video.addEventListener('loadeddata', () => {
        this.loaded = true;
      });
      this.video.addEventListener('dblclick', () => {
        if (!this.isTutorial) {
          this.video.requestFullscreen();
        }
      });
    }
    this.video.addEventListener('click', () => {
      if (this.video.paused) {
        this.play(true);
      } else {
        this.play(false);
      }
    });
    this.video.addEventListener('timeupdate', (e) => {
      this.handleTime((e.target as HTMLVideoElement).currentTime);
    });
  }
  videoplay() {
    this.play(true);
  }
  handleTime(currentTime: number) {
    if (currentTime > this.data.end && !this.isIos && this.isTutorial) {
      this.video.pause();
      this.video.currentTime = this.data.start;
      this.video.play();
    }
  }
  iosHandler() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      let currentTime = this.data.start;
      const video = this.video;
      let first = false;
      video.addEventListener(
        'canplay',
        function () {
          if (!first) {
            first = true;
            video.currentTime = currentTime;
          }
        },
        false
      );
      video.addEventListener('loadedmetadata', VideoMetaDataLoaded);
      function VideoMetaDataLoaded() {
        video.currentTime = currentTime;
      }
    }
  }
}
